import { tradeInReducer } from '@makemydeal/activities-tradein';
import { tradeInMiddleware } from './middleware';

export const tradeInConfiguration = {
    middleware: tradeInMiddleware,
    reducer: tradeInReducer
};
